// features/bookmarks/BookmarkTabs.tsx — type-filter tab bar.
import { Tabs } from '@/ui';
import { TYPE_TABS } from './meta';
import type { TypeFilter } from './meta';

export interface BookmarkTabsProps {
  active: TypeFilter;
  onChange: (type: TypeFilter) => void;
}

export function BookmarkTabs({ active, onChange }: BookmarkTabsProps) {
  return (
    <Tabs
      items={TYPE_TABS.map((t) => ({ value: t.id, label: t.label }))}
      value={active}
      onChange={(v) => onChange(v as TypeFilter)}
    />
  );
}
